// Copyright (c) 2017 Deere & Company

import ReimbursementSummaryDetailsData from '../state/data';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateData = (state, action) =>
    ReimbursementSummaryDetailsData.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().data, action) => {

    const actionTypes = {
        [actions.UPDATE_REIMBURSEMENT_SUMMARY_DETAILS_ROW_DATA]: updateData
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/reducers/data.js